import { defineStore } from "pinia";
import { ref } from "vue";

const VIEWPORT_VS_CLIENT_HEIGHT_RATIO = 0.75;

export const useAppStateStore = defineStore("appState", () => {
  const isLoading = ref(false);
  const isKeyboardActive = ref(false);
  const keyboardHeight = ref(0);

  if ("visualViewport" in window) {
    window.visualViewport?.addEventListener("resize", (event: Event) => {
      const target = event.target as VisualViewport | null;
      isKeyboardActive.value = target
        ? (target.height * target.scale) / window.screen.height < VIEWPORT_VS_CLIENT_HEIGHT_RATIO
        : false;
      keyboardHeight.value =
        isKeyboardActive.value && target ? window.innerHeight - target.height : 0;
    });
  }

  return {
    isLoading,
    isKeyboardActive,
    keyboardHeight,
  };
});
